export const siteUrl = "https://www.vipgroupsindia.com";

const sharedKeywords = [
  "VIP Groups India",
  "Veniinfra Projects Pvt Ltd",
  "Veni In Projects",
  "Veni In PhysioLife",
  "Veni Investment Planner",
  "Civil construction Tamil Nadu",
  "Building approval",
  "CMDA approval",
  "DTCP approval",
  "Construction material supply",
  "Physiotherapy clinic",
  "Investment planner",
  "LIC advisor",
  "Real estate consultancy",
];

export const defaultMeta = {
  title: "VIP Groups India | Veniinfra Projects, PhysioLife & Investment Planner",
  description:
    "VIP Groups India provides civil construction services, building approvals, construction material supply, physiotherapy care, investment planning, insurance guidance, and real estate consultancy in Tamil Nadu.",
  keywords: sharedKeywords,
  canonicalPath: "/",
  image: "/logo.png",
  schemaType: "Organization",
  businessName: "VIP Groups India",
};

export const routeMeta = {
  "/": defaultMeta,
  "/infra-projects": {
    title: "M/s Veniinfra Projects Pvt Ltd | Civil Construction Company in Tamil Nadu",
    description:
      "M/s Veniinfra Projects Pvt Ltd delivers civil construction, road works, building approval support, CMDA approval, DTCP approval, structural design, repair, fabrication, and real estate consultancy in Tamil Nadu.",
    keywords: [
      "M/s Veniinfra Projects Pvt Ltd",
      "Veniinfra Projects Pvt Ltd",
      "Civil construction Tamil Nadu",
      "Building contractors in Kattumannarkoil",
      "Building approval",
      "CMDA approval",
      "DTCP approval",
      "Structural design services Tamil Nadu",
      "Real estate consultancy Tamil Nadu",
    ],
    canonicalPath: "/infra-projects",
    image: "/gallery/infra/WhatsApp%20Image%202026-05-01%20at%2010.28.15.jpeg",
    schemaType: "ProfessionalService",
    businessName: "M/s Veniinfra Projects Pvt Ltd",
  },
  "/trading": {
    title: "M/s Veni In Projects | Construction Material Supply in Kattumannarkoil",
    description:
      "M/s Veni In Projects supports builders and contractors with cement trading, construction material supply, dispatch coordination, and equipment support.",
    keywords: [
      "M/s Veni In Projects",
      "Veni In Projects",
      "Construction material suppliers Tamil Nadu",
      "Cement supplier Kattumannarkoil",
      "Building material supply",
      "Contractor material supply",
    ],
    canonicalPath: "/trading",
    image: "/gallery/supply/WhatsApp%20Image%202026-05-01%20at%2009.54.13%20(1).jpeg",
    schemaType: "Store",
    businessName: "M/s Veni In Projects",
  },
  "/physio": {
    title: "M/s Veni In PhysioLife | Physiotherapy Clinic in Kattumannarkoil",
    description:
      "M/s Veni In PhysioLife provides physiotherapy, rehabilitation care, pain management, neuro physiotherapy, and mobility-focused treatment in Kattumannarkoil.",
    keywords: [
      "M/s Veni In PhysioLife",
      "Veni In PhysioLife",
      "Physiotherapy clinic in Kattumannarkoil",
      "Physiotherapy Tamil Nadu",
      "Pain management clinic",
      "Neuro physiotherapy",
      "Rehabilitation care",
    ],
    canonicalPath: "/physio",
    image: "/client/physio/p2.png",
    schemaType: "MedicalBusiness",
    businessName: "M/s Veni In PhysioLife",
    telephone: "+91 7708431557",
  },
  "/investment": {
    title: "M/s Veni Investment Planner | LIC Advisor & Investment Planner Tamil Nadu",
    description:
      "M/s Veni Investment Planner offers LIC advisory, insurance planning, risk protection, vehicle insurance, health insurance, banking loan guidance, and goal-based financial consultation in Tamil Nadu.",
    keywords: [
      "M/s Veni Investment Planner",
      "Veni Investment Planner",
      "Investment planner Tamil Nadu",
      "LIC advisor Tamil Nadu",
      "LIC planning",
      "Insurance advisor Tamil Nadu",
      "Financial consultation",
    ],
    canonicalPath: "/investment",
    image: "/gallery/invest/WhatsApp%20Image%202026-05-12%20at%2013.52.54%20(1).jpeg",
    schemaType: "FinancialService",
    businessName: "M/s Veni Investment Planner",
    telephone: "+91 9894365298",
  },
  "/gallery": {
    title: "VIP Groups India Gallery | Projects, Clinic, Trading & Investment Photos",
    description:
      "Explore VIP Groups India galleries for M/s Veniinfra Projects Pvt Ltd, M/s Veni In Projects, M/s Veni In PhysioLife, and M/s Veni Investment Planner.",
    keywords: [
      "VIP Groups India gallery",
      "Veniinfra Projects Pvt Ltd gallery",
      "Veni In Projects gallery",
      "Construction project photos Tamil Nadu",
      "Physiotherapy clinic gallery",
      "Investment planner office gallery",
    ],
    canonicalPath: "/gallery",
    image: "/gallery/infra/WhatsApp%20Image%202026-05-01%20at%2010.28.15.jpeg",
  },
  "/in-project": {
    canonicalPath: "/trading",
  },
  "/physio-life": {
    canonicalPath: "/physio",
  },
  "/investment-planner": {
    canonicalPath: "/investment",
  },
};

export function getMetaForPath(pathname) {
  const routeSpecific = routeMeta[pathname] || {};
  const canonicalSource = routeMeta[routeSpecific.canonicalPath] || {};

  return {
    ...defaultMeta,
    ...canonicalSource,
    ...routeSpecific,
    keywords: routeSpecific.keywords || canonicalSource.keywords || defaultMeta.keywords,
  };
}
